const UploadProgressReducer = (state, action) => ({
  ...state,
  files: action.payload
});

export default UploadProgressReducer;
